import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import buildings from '../../assets/editorial/2_predios.png';
import { editorial } from '../../editorial/editorialData';
import { useFontsReady } from '../../editorial/useFontsReady';

const Intro = ({ onNextPage, testMode }) => {
  const fontsReady = useFontsReady();
  const titleRef = useRef(null);
  const [blocked, setBlocked] = useState(false);
  const { titleLines, body } = editorial.intro;
  const emphasisAt = body.indexOf('Leia em voz alta.');
  const lead = emphasisAt === -1 ? body : body.slice(0, emphasisAt);
  const emphasis = emphasisAt === -1 ? '' : body.slice(emphasisAt);

  useEffect(() => () => setBlocked(false), []);

  useLayoutEffect(() => {
    const title = titleRef.current;
    if (!title || !fontsReady) return undefined;
    const line = title.querySelector('.intro-title-last');
    const fit = () => {
      const sheet = title.closest('.experience')?.clientWidth || 0;
      const target = title.clientWidth + sheet * 0.03;
      let low = 12;
      let high = 160;
      while (high - low > 0.2) {
        const mid = (low + high) / 2;
        title.style.fontSize = `${mid}px`;
        if (line.scrollWidth > target) high = mid;
        else low = mid;
      }
      title.style.fontSize = `${low}px`;
    };
    fit();
    window.addEventListener('resize', fit);
    return () => window.removeEventListener('resize', fit);
  }, [fontsReady]);

  const start = () => {
    if (!navigator?.mediaDevices?.getUserMedia && !testMode) {
      setBlocked(true);
      return;
    }
    onNextPage();
  };

  return (
    <div className="experience">
      <div className={clsx('intro-layout', fontsReady && 'is-on')}>
        <h1 ref={titleRef} className="intro-title intro-piece">
          {titleLines.map((line) => (
            <span key={line} className={line === titleLines.at(-1) ? 'intro-title-last' : undefined}>{line}</span>
          ))}
        </h1>
        <img
          className="intro-photo intro-piece"
          src={buildings}
          alt="Fachadas à beira do canal em Amsterdã"
        />
        <p className="intro-body intro-piece">
          {lead}
          {emphasis && <strong>{emphasis}</strong>}
        </p>
        <button type="button" className="intro-start intro-piece" onClick={start}>
          COMEÇAR
        </button>
        {blocked && (
          <p className="uncompatible-message">
            Este navegador ou dispositivo é incompatível com a funcionalidade de gravação de voz
          </p>
        )}
      </div>
    </div>
  );
};

export default Intro;
